import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
export default {
  name: 'springwaterList',
  meta: {
    title: '文物综合展示系统'
  },
  data() {
    return {
      singleform: {
        limit: 100,
        page: 1
      },
      firstData: [],
      datas: [],
      showFirst: true,
      datasAll: [],
      showIndex: [1],
      showBgIndex: [1],
      showFirstBg: true,
      config: {},
      stageUrl: '',
      pageType: ''
    };
  },
  methods: {
    toList() {
      let query = this.$route.query;
      let url = query.type == 'luoshen' ? 'new3DList' : 'springwaterList_s';
      this.$router.push({
        name: url,
        query: query
      });
    },
    // 获取文物列表
    getsingleformList() {
      this.singleform.fid = this.$route.query.fid || '151066';
      this.singleform.formId = 113010;
      this.$api.singleformList(this.singleform).then(res => {
        this.setData(res.data);
      });
    },
    //清洗数据
    setData(data) {
      data = data.map(item => {
        let nItem = {
          columnName: this.$route.query.fid == 200375 ? this.getValInFormData(item.formData, 'columns') : this.getValInFormData(item.formData, 'column'),
          name: this.getValInFormData(item.formData, 'antiqueName'),
          img: this.getValInFormData(item.formData, 'thumbnail', 'file'),
          code: this.getValInFormData(item.formData, 'autoId'),
          showType: this.getValInFormDataList(item.formData, 'showType'),
          autoCode: this.getValInFormData(item.formData, 'autoCode')
        };
        return nItem;
      });
      data = data.filter(item => {
        return item.showType.indexOf('电脑端与移动端') > -1;
      });
      let splitLength = Math.ceil(data.length / 9);
      for (let i = 0; i < data.length; i += 9) {
        this.datasAll.push(data.slice(i, i + 9));
      }
      if (this.datasAll.length < 3) {
        this.datasAll.push(this.datasAll[0]);
        this.datasAll.push(this.datasAll[1]);
      }
      setTimeout(() => {
        this.showIndex = [1, 2];
        setInterval(() => {
          let showIndex = JSON.parse(JSON.stringify(this.showIndex));
          this.showIndex[0] = showIndex[1];
          this.showIndex[1] = showIndex[1] == this.datasAll.length - 1 ? 0 : showIndex[1] + 1;
        }, 7000);
      }, 7000);
      setTimeout(() => {
        this.showBgIndex = [1, 2];
        setInterval(() => {
          let showBgIndex = JSON.parse(JSON.stringify(this.showBgIndex));
          this.showBgIndex[0] = showBgIndex[1];
          this.showBgIndex[1] = showBgIndex[1] == this.datasAll.length - 1 ? 0 : showBgIndex[1] + 1;
        }, 12000);
      }, 12000);
      setTimeout(() => {
        this.showFirst = false;
      }, 15000);
      setTimeout(() => {
        this.showFirstBg = false;
      }, 20000);
    },
    getValInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? this.stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    getValInFormDataList(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values;
      if (!target) return '';
      target = target.map(item => {
        return item.val;
      });
      return target.join(',');
    },
    toDetail(item) {
      let query = this.$route.query;
      query.code = item.code;
      item.autoCode ? query.autoCode = item.autoCode : '';
      if (query.type == 'luoshen') query.page = 2;
      this.$router.push({
        name: 'springwaterDetail',
        query: query
      });
    },
    // 获取页面配置
    getConfig() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          title: this.getConfigInFormData(data.formData, 'title'),
          logo: this.getConfigInFormData(data.formData, 'logo', 'img')
        };
        document.title = this.config.title || '文物综合展示系统';
      });
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      target.file = process.env.NODE_ENV == 'development' ? this.stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    }
  },
  created() {
    this.pageType = this.$route.query.type || '';
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    this.getConfig();
    if (this._isMobile()) {
      this.$cookie.set('_isMobile', true);
    } else {
      this.$cookie.delete('_isMobile');
    }
  },
  mounted() {
    this.singleform.fid = this.$route.query.fid || '151066';
    this.singleform.formId = '112706';
    this.getsingleformList();
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from);
    next(vm => {
      if (from.name == "springwaterDetail") {
        location.reload();
        return;
      }
    });
  }
};